import type { ServerProps } from '../../config/types.js'

export type PublishButtonClientProps = {}

export type PublishButtonServerPropsOnly = {} & ServerProps

export type PublishButtonServerProps = PublishButtonServerPropsOnly
